module.exports = __webpack_public_path__ + "img/windingtree.c2cb7e72.png";